import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetSubjects = (studentId) => {
    const {
        isLoading, data: subjects, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/subjects`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/subjects`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
    });

    return {
        isLoading,
        isRefetching,
        subjects: subjects || [],
        error,
        refetch,
    };
};
